@if (appliedFilterValues.length > 0) {
    <div class="sir-applied-filters-container">
        <p data-cy="applied-filters-text">{{ 'page.appliedFilters' | translate }}</p>
        <ul class="sir-applied-filters">
            @for (appliedFilter of appliedFilterValues; track appliedFilterTrackKey(appliedFilter)) {
                <li>
                    <button
                        type="button"
                        class="chubby-chip sir-text-style-system-m-default"
                        data-cy="applied-filter-chip"
                        [attr.aria-label]="
                            'page.removeAppliedFilterChip' | translate: { name: appliedFilter.value.name }
                        "
                        (click)="
                            onRemoveFilterIconClicked(
                                appliedFilter.filter.id,
                                appliedFilter.value.id
                            )
                        ">
                        {{ appliedFilter.value.name }}
                        <sirius-icon data-cy="icon" name="x" aria-hidden="true"></sirius-icon>
                    </button>
                </li>
            }
            <li class="sir-clear-all">
                <button
                    type="button"
                    class="sir-clear-all-button"
                    data-cy="clear-all-filters-button"
                    (click)="onClearButtonClicked()">
                    {{ 'button.clearAll' | translate }}
                </button>
            </li>
        </ul>
    </div>
}
